import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/*
  Breadcrumbs — Magazine ▸ Category ▸ Article.
  Accepts a list of { label, href? } items.
*/

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex items-center flex-wrap gap-1 text-[12px] text-neutral-500"
      data-testid="magazine-breadcrumbs"
    >
      {items.map((it, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <React.Fragment key={`${it.label}-${idx}`}>
            {idx > 0 && <ChevronRight className="w-3 h-3 text-neutral-300" />}
            {it.href && !isLast ? (
              <Link
                to={it.href}
                className="hover:text-[#F77F11] transition-colors font-medium"
              >
                {it.label}
              </Link>
            ) : (
              <span className={isLast ? 'text-neutral-700 font-medium' : ''}>
                {it.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
